module.exports = __webpack_public_path__ + "img/LP-BIGPACK-TACTICAL-GENESIS.b3dcbd97.jpg";